import './index.scss';
import React from 'react';
import _ from 'underscore';
import Header from './header';
import RequestInfo from './request_info';
import CancellationPolicy from './cancellation_policy';
import Pricing from './pricing';
import CoverGuideLogo from 'views/plugins/checkout/mobile/screens/cover/guide_logo';
import Picture from './picture';
import { formatDate } from 'views/plugins/booking_request/dates';
import { injectIntl } from 'react-intl';
import { Theme } from 'ui_system/theme';

class CheckoutSummary extends React.PureComponent {
  static displayName = 'CheckoutSummary';

  // If not a regular tour
  isCustomTour = () => {
    const { request } = this.props;
    return request.is_invoice || request.for_custom_booking;
  };

  pictureProps = () => {
    const { request } = this.props;
    return {
      tour_picture: this.isCustomTour()
        ? request.guide_avatar
        : request.tour_picture,
      rounded: this.isCustomTour(),
      hideOnMobile: true,
    };
  };

  headerProps = () => {
    return {
      tour_name_translation: this.props.request.tour_name_translation,
      guide_full_name: this.props.request.guide_full_name,
      tour_id: this.props.tour_id,
      is_invoice: this.props.request.is_invoice,
      for_custom_booking: this.props.request.for_custom_booking,
      has_resource: this.props.request.has_resource,
      resource_name: this.props.request.resource_name,
    };
  };

  cancellationPolicyProps = () => {
    const { request } = this.props;
    return {
      description: request.tour_cancellation_policy.description,
      name: request.tour_cancellation_policy.name,
      has_cancellation: request.has_cancellation,
      noShow:
        request.paid_in_cash ||
        request.for_custom_booking ||
        request.is_live_booking,
      bookingId: request.booking_id,
      time: request.time,
      is_mobile: Theme.mobile.isMobile,
    };
  };

  requestInfoProps = () => {
    const { intl, request, location, book_in_plugin, onEditDetailsClicked, is_booking_invoice } = this.props;
    return {
      locationLabel: location.label,
      date: formatDate(intl, request.date, true),
      time: request.time,
      duration: request.duration,
      number_of_guests: request.number_of_guests,
      committed: request.committed,
      book_in_plugin,
      origin_url: request.origin_url,
      onEditDetailsClicked,
      is_invoice: this.isCustomTour(),
      root_unit: request.root_unit,
      isoTime: request.iso_time,
      online: request.online,
      tourTimezone: request.tour_timezone,
      is_booking_invoice,
    };
  };

  pricingProps = () => {
    return {
      date: this.props.request.date,
      time: this.props.request.time,
      guide_full_name: this.props.request.guide_full_name,
      for_zero_priced_tour: this.props.request.for_zero_priced_tour,
      bookingId: this.props.request.booking_id,
    };
  };

  render() {
    const { request } = this.props;
    return (
      <div className="CheckoutSummary-Container">
        {request?.for_custom_booking && (
          <CoverGuideLogo
            picture={request.guide_avatar}
            tourName={request.tour_name_translation}
            guideName={request.guide_full_name}
            key="guide-logo"
          />
        )}
        <Picture {...this.pictureProps()} />
        <div className="CheckoutSummary">
          <Header {...this.headerProps()} />
          <RequestInfo {...this.requestInfoProps()} />
          <CancellationPolicy {...this.cancellationPolicyProps()} />
          <Pricing {...this.pricingProps()} />
        </div>
      </div>
    );
  }
}

export default injectIntl(CheckoutSummary);
